module.exports = __webpack_public_path__ + "static/modellierung-946028bd22f10fadee1a4250699d31b5.png";